import { render, staticRenderFns } from "./IpsCheckbox.vue?vue&type=template&id=65cab10a"
import script from "./IpsCheckbox.vue?vue&type=script&lang=js"
export * from "./IpsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports